import markItemsJunkNotJunkFromTable from './helpers/markItemsJunkNotJunkFromTable';
import markConversationsJunkNotJunkFromTable from './helpers/markConversationsJunkNotJunkFromTable';
/**
 * Mark the rows as junk or not junk
 * @param rowKeys of the rows to be marked as junk/not junk
 * @param tableView that contains the rows
 * @param isJunkValueToSet whether to mark as junk or not junk
 * @param actionSource the action source
 */
export default function markRowsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            markConversationsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
        case 1 /* Message */:
            markItemsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
    }
}
//# sourceMappingURL=markRowsJunkNotJunkFromTable.js.map